import store from '../store/index'
let defaultBeforeClose = function () {
  return new Promise((resolve) => {
    store.dispatch('L/confirm', {
      title: '确认关闭此页 ？',
      // text: '确认关闭此页 ？',
      text: '未提交的更改将不会保存',
      confirmText: '关闭此页',
    })
      .then(({res, close}) => {
        close()
        resolve(res)
      })
  })
}
export default {
  defaultBeforeClose
}
